import React from 'react';
import { Anchor, Box, DataTable, Page, PageContent } from 'grommet';
import { API } from '@enrich/shared-lib';
import QueryString from 'qs';
import { useLoaderData } from 'react-router-dom';

export const ListsDashboard = () => {
    const jobs = useLoaderData();
    const dataColumns = [
        {
            header: 'List Name',
            property: 'attributes.name',
            render: (list) => {
                return (
                    <Anchor
                        href={`/lists/${list.id}`}
                        label={list.attributes.name}
                    />
                );
            },
            sortable: true,
        },
        {
            header: 'Students',
            property: 'attributes.contacts.data.attributes.count',
            sortable: true,
        },
    ];

    return (
        <Page
            kind="full"
            pad={{ top: '30px', horizontal: 'medium', bottom: '30px' }}>
            <PageContent>
                <Box gap="small">
                    <Box>
                        <DataTable
                            primaryKey="id"
                            sortable
                            data={jobs}
                            columns={dataColumns}
                        />
                    </Box>
                </Box>
            </PageContent>
        </Page>
    );
};

export const loader = async () => {
    const query = QueryString.stringify({
        populate: {
            contacts: {
                count: true,
            },
        },
    });

    try {
        const response = await API.get(`/api/contact-lists?${query}`);
        return response.data.data;
    } catch (error) {
        console.log(error);
    }

    return [];
};
